module.exports = __webpack_public_path__ + "static/media/Illus-Birthday@3x.4dfa3947.png";